import { AxiosError } from 'axios';
import { getUserRequestsUrl } from 'constants/urls';
import { UserContext } from 'context/UserContext';
import { useSWRAxios } from 'hooks/useSWRAxios';
import { useContext } from 'react';
import { PaginatedApiResponse } from 'types/api';
import { Request, RequestQueryParams, RequestType } from './types';

export const useRequests = (params: RequestQueryParams) => {
    const { user } = useContext(UserContext);
    const url = getUserRequestsUrl(user?.id || '');
    const { data, ...restProperties } = useSWRAxios<
        PaginatedApiResponse<Request>,
        AxiosError<{ message: string }>,
        {
            fallbackData: PaginatedApiResponse<Request>;
        }
    >({
        url,
        params
    });

    return {
        ...restProperties,
        requests: data
    };
};

export const useMapOpenRequests = () => {
    return useRequests({ type: RequestType.ONBOARDING_MAP, isResolved: false });
};
